export default function useValores(fuente: Record<string, any>) {

    const getValor = (modelo) => {
        const isObject = typeof (modelo) === "object" && modelo !== null

        if (isObject) {
            return modelo.valor
        }

        return modelo?.toString()?.split(".").reduce((p, c) => (p?.[c]), fuente);
    };

    const asignarDesdeObj = (params) => {

        return params && Object.entries(params
        ).reduce((p, [k, v]) => {
            return { ...p, [k]: getValor(v) }
        }, {})

    };

    return {
        getValor,
        asignarDesdeObj
    }

}